import React, { Component } from 'react'
import { Button, Card, Col, Divider, Form, Row } from 'antd'
import CustomTable from '../../../../elements/Table/CustomTable'
import withLoadingSection from '../../../../elements/HOC/withLoadingSection'
import { compose } from 'recompose'
import { strVal } from '../../../../modules/Utils'

const ButtonGroup = Button.Group

class MemberList extends Component {
  render () {
    const formItemLayoutRow = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
    const { next, listExist, fetching, setMember, supplierRegistration, fetchBank } = this.props

    return (
      <div className="steps-content">
        <Card style={{ width: 500, marginBottom: 5, marginTop: 50 }}>
          <Row gutter={16} style={{ marginBottom: 5, marginTop: 10 }}>
            <Col span={10} style={{ fontWeight: 'bold' }}>
              Registered Name :
            </Col>
            <Col span={14}>{strVal(supplierRegistration, 'business.registeredName')}</Col>
          </Row>
          <Row gutter={16} style={{ marginBottom: 5 }}>
            <Col span={10} style={{ fontWeight: 'bold' }}>
              Trading Name :
            </Col>
            <Col span={14}>{strVal(supplierRegistration, 'business.tradingName')}</Col>
          </Row>
        </Card>
        <Divider orientation="left">Select From Existing Member</Divider>
        <Row>
          <CustomTable
            data={listExist.members}
            hide={{ create: true, refresh: true }}
            isFilterable={true}
            fetching={fetching}
            show={{ extraColumns: true }}
            defaultFiltered={[
              {
                id: 'fn',
                value: strVal(supplierRegistration, 'business.registeredName').substring(0, 7),
              },
            ]}
            columns={[
              {
                Header: 'Registered Name',
                accessor: 'fn',
                width: 350,
              },
              {
                Header: 'Trading Name',
                accessor: 'tradeName',
              },
              {
                Header: 'Registered Number',
                accessor: 'companyno',
                width: 130,
              },
              {
                Header: 'Registration Date',
                accessor: 'registrationDate',
                width: 100,
                hideable: true,
                hideDefault: true,
              },
              {
                Header: 'Country',
                accessor: 'adr[0].value.country',
              },
              {
                Header: 'State',
                accessor: 'adr[0].value.state',
                hideable: true,
                hideDefault: true,
              },

              {
                Header: 'City',
                accessor: 'adr[0].value.city',
                hideable: true,
                hideDefault: true,
              },
              {
                Header: 'Postal Code',
                accessor: 'adr[0].value.postcode',
                hideable: true,
                hideDefault: true,
              },
              {
                Header: 'Action',
                width: 50,
                Cell: ({ value, original }) => (
                  <Button
                    type="primary"
                    size="small"
                    onClick={() => {
                      setMember(original, 'use')
                      fetchBank(original._id)
                      next()
                    }}>
                    Use
                  </Button>
                ),
              },
            ]}
          />
        </Row>
      </div>
    )
  }
}

export default compose(Form.create(), withLoadingSection)(MemberList)
